// ----------------------------------------------------
// src/Components/ContactSection.jsx
// ----------------------------------------------------

import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import emailjs from "@emailjs/browser";
import { FaPhoneAlt, FaEnvelope, FaGlobe, FaMapMarkerAlt } from "react-icons/fa";
import { myCustomTheme as theme } from "../Theme";
import "../Style/ContactForm.css";

const ContactSection = () => {
  // Access contact data from Redux store
  const { contact } = useSelector((state) => state.contact);
  const form = useRef();
  const [status, setStatus] = useState("idle");

  // Handler for form submission via EmailJS
  const sendEmail = (e) => {
    e.preventDefault();
    setStatus("sending");
    emailjs.sendForm("service_9cobyqr", "template_2d1svug", form.current, "xVYfLbxT6ddEuB_re")
      .then(() => {
        setStatus("success");
        e.target.reset();
        setTimeout(() => setStatus("idle"), 3000);
      })
      .catch(() => {
        setStatus("error");
        setTimeout(() => setStatus("idle"), 3000);
      });
  };

  // Helper to map icon types to React icons
  const getIcon = (type) => {
    switch (type) {
      case "phone": return <FaPhoneAlt />;
      case "email": return <FaEnvelope />;
      case "website": return <FaGlobe />;
      default: return <FaMapMarkerAlt />;
    }
  };

  return (
    <section className="contact-section" style={{ background: theme.colors.bg_primary }}>
      <div className="contact-container">
        
        {/* LEFT SIDE: MODERN PILL FORM */}
        <div className="contact-left">
          <span className="contact-subtitle" style={{ color: theme.colors.menu_text, fontFamily: theme.typography.heading_font}}>
            CONTACT
          </span>
          <h1 className="contact-title" style={{ color: theme.colors.heading, fontFamily: theme.typography.heading_font }}>
            Get In Touch
          </h1>
          <p className="contact-desc" style={{ color: theme.colors.menu_text, fontFamily: theme.typography.text_font }}>
            Aliquam pellen tesque est orci, viverra sodales est congue ut. 
            Praesent vitae turpiso ut felis porta porttitor nec a libero.
          </p>

          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <input type="text" name="user_name" placeholder="Name" required />
            <input type="email" name="user_email" placeholder="Email" required />
            <input type="text" name="subject" placeholder="Subject" required />
            <textarea name="message" placeholder="Message" rows="5" required />

            <button
              type="submit"
              disabled={status === "sending"}
              className={`submit-btn ${status}`}
              style={{ 
                background: theme.colors.button_bg, 
                color: theme.colors.button_text,
                boxShadow: theme.shadows.soft 
              }}
            >
              {status === "sending" ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>

        {/* RIGHT SIDE: CRAZY NEUMORPHIC INFO TILES */}
        <div className="contact-right-crazy">
          {contact.contactInfo.map((item, index) => (
            <div 
              className="info-tile" 
              key={item.id}
              style={{ 
                background: theme.colors.header_footer_bg,
                boxShadow: theme.shadows.neumorphic,
              }}
            >
              <div className="tile-icon-box" style={{ background: theme.colors.bg_primary, boxShadow: theme.shadows.icon_box }}>
                <span style={{ color: theme.colors.heading }}>{getIcon(item.type)}</span>
              </div>
              <div className="tile-content">
                <h3 style={{ color: theme.colors.heading, fontFamily: theme.typography.text_font }}>{item.title}</h3>
                <p style={{ color: theme.colors.menu_text, fontFamily: theme.typography.text_font }}>{item.description}</p>
                <div className="tile-value">
                  {item.type === "email" ? (
                    <a href={`mailto:${item.value}`} style={{ color: theme.colors.heading, fontFamily: theme.typography.text_font }}>{item.value}</a>
                  ) : item.type === "website" ? (
                    <a href={`https://${item.value}`} target="_blank" rel="noreferrer" style={{ color: theme.colors.heading, fontFamily: theme.typography.text_font }}>{item.value}</a>
                  ) : (
                    <span style={{ color: theme.colors.heading, fontFamily: theme.typography.text_font }}>{item.value}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* DARK MAP PRESERVED */}
      <div className="map-section-dark">
        <iframe
          title="Google Map"
          src={contact.mapUrl}
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default ContactSection;